import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom"
import axios from "axios";
import Avatar from '@mui/material/Avatar';
import { Button, TextField } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import swal from "sweetalert";
import Swal from 'sweetalert2'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import EmsNavbar from "../../frontend/EmsNavbar";
import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
//import WorkshopFooter from "./WorkhopFooter/WorkshopFooter";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useMediaQuery, useTheme } from '@mui/material';
import { useDeadline } from "../../contexts/DeadlineContext";
const WorkShopParticpantVeri = () => {
    const eventid = localStorage.getItem('eventid')
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [loaded, setLoaded] = useState(false);

    // useEffect(() => {
    //     const firstLoadFlag = localStorage.getItem('firstLoadComplete');
    //     if (!firstLoadFlag) {
    //         // Set the flag to indicate that the first load has been completed
    //         localStorage.setItem('firstLoadComplete', 'true');
    //         // Reload the page only once
    //         window.location.reload();
    //     }
    // }, []);
    const gradientBackground = '#05597D';
    const facebookLink = abstractHomeSetup.facebook_link && abstractHomeSetup.facebook_link.startsWith('http')
        ? abstractHomeSetup.facebook_link
        : `https://${abstractHomeSetup.facebook_link || ''}`;

    const InstagramLink = abstractHomeSetup.Instagram_link && abstractHomeSetup.Instagram_link.startsWith('http')
        ? abstractHomeSetup.Instagram_link
        : `https://${abstractHomeSetup.Instagram_link || ''}`;

    const LinkedinLink = abstractHomeSetup.linkedin_link && abstractHomeSetup.linkedin_link.startsWith('http')
        ? abstractHomeSetup.linkedin_link
        : `https://${abstractHomeSetup.linkedin_link || ''}`;

    const twitterLink = abstractHomeSetup.twitter_link && abstractHomeSetup.twitter_link.startsWith('http')
        ? abstractHomeSetup.twitter_link
        : `https://${abstractHomeSetup.twitter_link || ''}`;




    let sponsorLogos = [];

    // Parse abstractSponserLogos if it's a JSON string
    if (abstractHomeSetup.abstractSponserLogos && typeof abstractHomeSetup.abstractSponserLogos === 'string' && abstractHomeSetup.abstractSponserLogos.trim() !== '') {
        try {
            sponsorLogos = JSON.parse(abstractHomeSetup.abstractSponserLogos);
        } catch (e) {
            console.error("Error parsing abstractSponserLogos:", e);
            sponsorLogos = [];
        }
    }

    const Footerbackground = 'linear-gradient(90deg, rgba(20, 65, 102, 1) 0%, rgba(20, 66, 103, 1) 36%, rgba(7, 25, 39, 1) 100%)';


    const history = useHistory();

    const [emailexist, setemailexist] = useState({
        email: "",
        error_list: [],

    });
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    useEffect(() => {
        // Disable the button initially if the email is not valid or empty
        setIsButtonDisabled(Boolean(emailexist.error_list.email) || emailexist.email === "");
    }, [emailexist.error_list.email, emailexist.email]);


    const handleInput = (e) => {
        e.persist();
        const { name, value } = e.target;
        setemailexist({ ...emailexist, [name]: value });

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (name === 'email' && value) {
            if (!emailRegex.test(value)) {
                setemailexist(prevState => ({
                    ...prevState,
                    error_list: { ...prevState.error_list, email: 'Please enter a valid email address' }
                }));
            } else {
                setemailexist(prevState => ({
                    ...prevState,
                    error_list: { ...prevState.error_list, email: '' }
                }));
                setIsButtonDisabled(false);
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            email: emailexist.email,
            eventid,
        }

        if (emailexist.email != "") {
            localStorage.setItem('workshop_particpant_email', emailexist.email);

        }

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`api/participant-email`, data).then(res => {
                if (res.data.redirect == 0) {
                    const searchingEmain = res.data.checkEmail;
                    const id = searchingEmain.id;
                    //setworkshopParticipentEmailFind(searchingEmain)
                    //swal("Success", "Email Already Registered", "success")
                    history.push(`/workshop/registration-update/${id}`);

                }
                if (res.data.redirect == 1) {

                    history.push('/workshop/particpant-form')
                    return false;
                }
                else {
                    setemailexist({ ...emailexist, error_list: res.data.validate_error });

                }
            })
        });


    };




    //const eventid = localStorage.getItem('eventid'); // eventid will be a string, e.g., "61"
    //const  AllSeatsAreFull = event_id === "61"

    const event_id = parseInt(localStorage.getItem('eventid'), 10); // Now it's a number 61
    //const AllSeatsAreFull = event_id === 61; 
    const conferenceLink = () => {
        history.push('/conference/particpant-verification');
        //http://localhost:3000/#/workshop/registration/66
    }


    useEffect(() => {
    const img = new Image();
    img.src = abstractHomeSetup?.workshopBannerImage || "https://via.placeholder.com/800x600";
}, [abstractHomeSetup?.workshopBannerImage]);


    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <WorkshopNavbar />
            </Grid>
            <Grid container spacing={2}>
                {/* <Box
                    sx={{
                        position: 'relative',
                        marginTop: '10px',
                        width: '100%',
                        height: isSmallScreen ? '200px' : '700px', // Adjust height for small screens
                        //backgroundImage: `url(${bannerImage})`,
                        backgroundImage: `url(${abstractHomeSetup?.workshopBannerImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: isSmallScreen ? 'center' : 'left',
                        padding: isSmallScreen ? '10px' : '20px', // Adjust padding for small screens
                        color: 'white',
                    }}
                >
                    <Typography variant={isSmallScreen ? 'h6' : 'h2'} component="div">
                        Workshop Management System
                    </Typography>
                </Box> */}


                
                <Box sx={{ position: 'relative', width: '100%', marginTop: '16px' }}>
                    {!loaded && (
                        <Box sx={{ width: '100%', height: isSmallScreen ? 200 : 700, background: '#ccc' }} />
                    )}
                    <img
                        src={abstractHomeSetup?.workshopBannerImage || "https://via.placeholder.com/800x600"}
                        alt="Workshop Banner"
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: loaded ? 'block' : 'none',
                        }}
                        onLoad={() => setLoaded(true)}
                    />
                </Box>

                {/* <Box
                    sx={{
                        position: 'relative',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '16px',
                    }}
                >
                    <img
                        src={abstractHomeSetup?.workshopBannerImage || "https://via.placeholder.com/800x600"}
                        alt="Workshop Banner"
                        style={{
                            width: '100%',       // full width
                            height: 'auto',      // maintain aspect ratio
                            display: 'block',    // remove bottom gap
                        }}
                    />
                </Box> */}

               
                <Grid container justifyContent="center" marginTop={abstractHomeSetup?.c_bank_status === 1 || abstractHomeSetup?.c_cash_status === 1 || abstractHomeSetup?.c_free_status === 1 || abstractHomeSetup?.c_online_status === 1 ? "0" : "40px"}>
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        {(abstractHomeSetup?.c_bank_status === 1 || abstractHomeSetup?.c_cash_status === 1 || abstractHomeSetup?.c_free_status === 1 || abstractHomeSetup?.c_online_status === 1) && (
                            <>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" }, // column on mobile, row on medium+
                                        justifyContent: { xs: "center", md: "space-between" },
                                        alignItems: { xs: "center", md: "center" },
                                        mt: { xs: 2, md: 5 }, // smaller margin on mobile, larger on desktop
                                        mb: 1,
                                        gap: { xs: 1, md: 0 }, // spacing only when stacked
                                    }}
                                >
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: "bold",
                                            color: abstractHomeSetup?.color_code_two || "#05597D",
                                            ml: { xs: 0, md: 7 }, // no margin on mobile, keep margin on large
                                            textAlign: { xs: "center", md: "left" }, // center text on mobile
                                            fontSize: { xs: "1.2rem", md: "2rem" }, // smaller on mobile
                                        }}
                                    >
                                        Workshop Registration
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup?.color_code_two
                                                ? abstractHomeSetup?.color_code_two
                                                : gradientBackground,
                                            color: "white",
                                            whiteSpace: "nowrap",
                                            mr: { xs: 0, md: 8 }, // keep margin only on large
                                            width: { xs: "80%", md: "auto" }, // full width on mobile, auto on large
                                            fontSize: { xs: "0.8rem", md: "1rem" }, // smaller text on mobile
                                            py: { xs: 0.6, md: 1 }, // smaller padding on mobile
                                        }}
                                        onClick={conferenceLink}
                                    >
                                        For Conference Registration Click Here
                                    </Button>
                                </Box>
                            </>
                        )}
                        <Box component="form" onSubmit={handleSubmit}
                            sx={{
                                boxShadow: 3,
                                borderRadius: 2,
                                padding: 4,
                                ml: { xs: 3, md: 5 }, // add left margin only on medium+ screens
                                width: '100%',
                                maxWidth: isSmallScreen ? '309px' : '600px', // Initial maxWidth for smaller screens
                                textAlign: 'center',
                                background: abstractHomeSetup?.color_code_four
                                    ? abstractHomeSetup?.color_code_four
                                    : gradientBackground,
                                color: 'white',
                                marginX: 'auto',
                                '@media (min-width: 960px)': {
                                    maxWidth: '800px', // Increase maxWidth on larger screens if needed
                                },
                            }}
                        >
                            <Typography component="h1" variant="h5">
                                Verify your Email
                            </Typography>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                autoComplete="off"
                                id="email"
                                label="Email Address"
                                name="email"
                                autoFocus
                                onChange={handleInput}
                                value={emailexist.email}
                                helperText={emailexist.error_list.email}
                                InputLabelProps={{
                                    style: { color: 'white' }, // Set label text color
                                }}
                                FormHelperTextProps={{
                                    style: { color: 'white' }, // Set helper text color
                                }}
                                InputProps={{
                                    style: {
                                        color: 'white', // Set text color inside the input
                                        '&::placeholder': {
                                            color: 'white', // Set placeholder text color
                                            opacity: 0.7, // Adjust opacity if needed
                                        },
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '25px', // Adjust the value as needed
                                        color: 'white', // Set text color inside the input field
                                        '& fieldset': {
                                            borderColor: 'white', // Set border color for the input
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'white', // Set border color on hover
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'white', // Set border color when focused
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: 'white !important', // Ensure label text color is white
                                    },
                                    '& .MuiFormHelperText-root': {
                                        color: 'white !important', // Ensure helper text color is white
                                    },
                                }}
                            />
                            {/* {
                                AllSeatsAreFull ? (
                                    <h1>Workshops Seats Are Full</h1>
                                ) : (
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        autoComplete="off"
                                        id="email"
                                        label="Email Address"
                                        name="email"
                                        autoFocus
                                        onChange={handleInput}
                                        value={emailexist.email}
                                        helperText={emailexist.error_list.email}
                                        InputLabelProps={{
                                            style: { color: 'white' }, // Set label text color
                                        }}
                                        FormHelperTextProps={{
                                            style: { color: 'white' }, // Set helper text color
                                        }}
                                        InputProps={{
                                            style: {
                                                color: 'white', // Set text color inside the input
                                                '&::placeholder': {
                                                    color: 'white', // Set placeholder text color
                                                    opacity: 0.7, // Adjust opacity if needed
                                                },
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '25px', // Adjust the value as needed
                                                color: 'white', // Set text color inside the input field
                                                '& fieldset': {
                                                    borderColor: 'white', // Set border color for the input
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'white', // Set border color on hover
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'white', // Set border color when focused
                                                },
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'white !important', // Ensure label text color is white
                                            },
                                            '& .MuiFormHelperText-root': {
                                                color: 'white !important', // Ensure helper text color is white
                                            },
                                        }}
                                    />
                                )
                            } */}



                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                disabled={isButtonDisabled}
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    background: abstractHomeSetup?.color_code_two
                                        ? abstractHomeSetup?.color_code_two
                                        : gradientBackground,
                                    borderRadius: '25px', // Adjust the value as needed
                                }}
                            >
                                Verify
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    );
}


export default WorkShopParticpantVeri;
